'use strict';

import Home from './Home.svelte';
import Cart from './Cart.svelte';
import Order from './Order.svelte';
import OrderNew from './OrderNew.svelte';
import OrderAll from './OrderAll.svelte';
import OrderAllPage from './OrderAllPage.svelte';
import OrderPending from './OrderPending.svelte';
import OrderDelivered from './OrderDelivered.svelte';
import Users from './Users.svelte';
import OrderDetail from './OrderDetail.svelte';
import OrderSuccess from './OrderSuccess.svelte';
import Products from './Products.svelte';
import ProductsContent from './ProductsContent.svelte';
import About from './About.svelte';
import Location from './Location.svelte';
import Settings from './Settings.svelte';
import Address from './Address.svelte';
import Terms from './Terms.svelte';
import NotFound from './404.svelte';
import { getProfile } from "./UserService.js";
import { dirty } from "./stores.js";
import { get } from "svelte/store";
import { format } from "./i18n.js";

export default [
  {
    path: '/',
    component: Home,
    title: 'routes.home'
  },
  {
    path: '/Home',
    component: Home,
    title: 'routes.home'
  },
  {
    path: '/Products',
    component: Products,
    title: 'routes.products',
    tabs: [
      {
        path: '/',
        id: 'All',
        component: ProductsContent,
        title: 'routes.allProducts'
      },
      {
        path: '/Tueyhom',
        id: 'Tueyhom',
        component: ProductsContent,
        title: 'routes.tueyhomProducts'
      },
      {
        path: '/Fuji',
        id: 'Fuji',
        component: ProductsContent,
        title: 'routes.fujiProducts'
      }
    ]
  },
  {
    path: '/Cart',
    component: Cart,
    title: 'routes.cart'
  },
  {
    path: '/Order',
    title: 'routes.order',
    async(routeTo, routeFrom, resolve, reject) {
      getProfile().then(function (profile) {
        resolve({ component: Order }, {
          context: {
            admin: profile.admin === true
          }
        })
      });
    },
    tabs: [
      {
        path: '/New',
        id: 'New',
        component: OrderNew,
        title: 'routes.newOrder',
      },
      {
        path: '/My',
        id: 'My',
        component: OrderAll,
        title: 'routes.myOrders',
      },
      {
        path: '/Pending',
        id: 'Pending',
        component: OrderPending,
        title: 'routes.pendingOrders'
      },
      {
        path: '/Delivered',
        id: 'Delivered',
        component: OrderDelivered,
        title: 'routes.deliveredOrders'
      },
      {
        path: '/Users',
        id: 'Users',
        component: Users,
        title: 'routes.userOrders'
      }
    ]
  },
  {
    path: '/Order/All/:id',
    component: OrderAllPage,
    title: 'routes.orderDetails'
  },
  {
    path: '/Order/All/:id/:name',
    component: OrderAllPage,
    title: 'routes.orderDetails'
  },
  {
    path: '/Order/Success/:id',
    component: OrderSuccess,
    title: 'routes.orderSuccess'
  },
  {
    path: '/Order/:id',
    component: OrderDetail,
    title: 'routes.orderDetails'
  },
  {
    path: '/About',
    component: About,
    title: 'routes.about'
  },
  {
    path: '/Location',
    component: Location,
    title: 'routes.addressLocation'
  },
  {
    path: '/Address/:userId/:addressId',
    component: Address,
    title: 'routes.addressDetails',
    beforeLeave: async function (routeTo, routeFrom, resolve, reject) {
      let router = this.view.router;
      const { pushStateRoot = '', pushStateSeparator } = this.params;
      if (get(dirty) && !routeTo.path.startsWith("/Location")) {
        this.app.dialog.confirm(
          format("routes.leavePage"),
          function () {
            resolve();
          },
          function () {
            let url = routeFrom.url;
            history.pushState({ "view_main": { "url": url } }, '', pushStateRoot + pushStateSeparator + url);
            reject();
            router.allowPageChange = true;
          }
        );
      } else {
        resolve();
      }
    }
  },
  {
    path: '/Settings',
    component: Settings,
    title: 'routes.settings'
  },
  {
    path: '/Terms',
    component: Terms,
    title: 'routes.terms'
  },
  {
    path: '(.*)',
    component: NotFound,
    title: 'routes.pageNotFound'
  }
];